import { b as a } from "./core-DVmjA3_O.js";
function o() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.filter(a).join(" ");
}
export {
  o as _
};
